export const SET_STOCK_PRODUCT_REQ = "SET_STOCK_PRODUCT_REQ";
export const SET_STOCK_ORDER_PRODUCTS = "SET_STOCK_ORDER_PRODUCTS";
export const UPDATE_STOCK_ORDER_PRODUCTS = "UPDATE_STOCK_ORDER_PRODUCTS";
export const SET_STOCK_ALL_PRODUCTS = "SET_STOCK_ALL_PRODUCTS";
export const SET_STOCK_UNIQUE_IMEIS = "SET_STOCK_UNIQUE_IMEIS";
export const SET_FILTER_UNIQUE_IMEIS = "SET_FILTER_UNIQUE_IMEIS";
export const SET_CANCEL_UNIQUE_IMEIS = "SET_CANCEL_UNIQUE_IMEIS";
export const SET_CLEAR_STOCK_UNIQUE_IMEIS = "SET_CLEAR_STOCK_UNIQUE_IMEIS";
export const UPDATE_UNIQUE_IMEIS = "UPDATE_UNIQUE_IMEIS";
